import { Box, BoxProps } from "@chakra-ui/react";
import { FiPlus } from "react-icons/fi";

export const PlusIcon = (props: BoxProps) => {
  return <Box as={FiPlus} height="20px" width="20px" {...props} />;
};
